import React from 'react';
import { Box, Typography } from '@mui/material';
import { IPD_COLORS, ipdCardSx } from './ipdColors';

export default function IpdSectionCard({ title, subtitle, actions, children, sx = {}, noPadding = false }) {
  const flexContent = sx.display === 'flex' || sx.flex === 1;

  return (
    <Box sx={{ ...ipdCardSx, color: IPD_COLORS.textPrimary, overflow: 'hidden', minWidth: 0, maxWidth: '100%', ...sx }}>
      {(title || actions) && (
        <Box sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          flexWrap: 'wrap',
          gap: 1,
          px: { xs: 1.5, sm: 2.5 },
          py: 1.5,
          borderBottom: `1px solid ${IPD_COLORS.border}`,
          backgroundColor: IPD_COLORS.cardBg,
          flexShrink: 0,
        }}>
          <Box sx={{ minWidth: 0, flex: '1 1 180px' }}>
            {title && (
              <Typography sx={{ color: IPD_COLORS.textPrimary, fontWeight: 600, fontSize: 15 }}>
                {title}
              </Typography>
            )}
            {subtitle && (
              <Typography sx={{ color: IPD_COLORS.textSecondary, fontSize: 12, mt: 0.25 }}>
                {subtitle}
              </Typography>
            )}
          </Box>
          {actions && (
            <Box sx={{ display: 'flex', gap: 1, alignItems: 'center', flexWrap: 'wrap', flexShrink: 0 }}>
              {actions}
            </Box>
          )}
        </Box>
      )}
      <Box sx={{
        ...(noPadding ? {} : { p: { xs: 1.5, sm: 2.5 } }),
        ...(flexContent ? { flex: 1, minHeight: 0, display: 'flex', flexDirection: 'column' } : {}),
      }}>
        {children}
      </Box>
    </Box>
  );
}
